import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { Typography, Box } from '@mui/material';
import { poppins400, poppins500 } from 'theme/common.style';
import Avatar from 'antd/es/avatar/avatar';
import { Contact, OfferContainer } from './BuyerRegistration.util';
import { getApiCall } from 'api/apiService';
import { GET_BINDERID } from 'constant/app.config';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const CounterOfferTable = ({
  tableData,
  onShowChat,
  userTypeValue,
  manageOfferData,
}) => {
  const params = useParams();
  const propertyId = params?.dashboardId;
  const offerHistory = manageOfferData?.offerHistory || [];
  const counterOfferBuyerLists = offerHistory
    .map((offer) => offer.counterOfferBuyerList || [])
    .flat();
  const CircularProgressWithProfile = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  fontFamily: 'poppins',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt="Remy"
                src={props.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FFFFFF',
      border: '0.81px solid',
      borderRadius: 2.42,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background:
        'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));

  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    return (
      <div style={{ position: 'relative', cursor: 'pointer' }}>
        <BorderLinearProgress variant="determinate" value={props.value} />
        <TextOverlay
          sx={{ color: 'white', textShadow: '-1px 1px 0px black' }}
          variant="body2"
          color="textSecondary"
          leftPosition={'50%'}
        >
          {`${Math.round(props.value)}%`}
        </TextOverlay>
      </div>
    );
  }

  const GreyPaper = () => {
    return (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#C4C4C4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
        />
      </svg>
    );
  };

  const ColorPaper = () => {
    return (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
          fill="#6C2AD2"
        />
      </svg>
    );
  };

  return (
    <TableContainer
      sx={{
        '-webkit-scrollbar': {
          display: 'none',
        },
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none',
      }}
    >
      <Table
        sx={{
          overflow: 'hidden',
          '& .MuiTableCell-root': {
            padding: '5px',
          },
        }}
        aria-labelledby="tableTitle"
        size="medium"
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
                paddingLeft: '60px !important',
              }}
            >
              Name
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
              }}
            >
              Contact
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                width: '25%',
                color: '#666666',
              }}
            >
              Buyer Readiness
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                width: '10%',
                color: '#666666',
              }}
            >
              Status
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
              }}
            >
              Offer
            </TableCell>
            <TableCell
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                fontFamily: 'poppins',
                textAlign: 'left',
                color: '#666666',
              }}
            >
              Shared
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData?.map((row, index) => {
            const hasHistory = counterOfferBuyerLists.some(
              (buyer) =>
                buyer.buyerId == row?.buyerDetails?.user?.userId &&
                buyer?.historyCreated
            );
            if (hasHistory) {
              return (
                <TableRow key={index}>
                  <TableCell>
                    <Typography sx={{ ...userDetCont, paddingLeft: '0px' }}>
                      <Typography sx={imageCont}>
                        <Typography
                          sx={displayFlex}
                          style={{
                            justifyContent: 'center',
                            position: 'relative',
                            alignItems: 'center',
                            paddingRight: '10px',
                          }}
                        >
                          <CircularProgressWithProfile
                            value={row?.buyerDetails?.profileActivity}
                            profileImage={row?.buyerDetails?.user?.userProfile}
                            name={
                              row?.buyerDetails?.user?.userName
                                .charAt(0)
                                ?.toUpperCase() +
                              row?.buyerDetails?.user?.userSurName
                                .charAt(0)
                                ?.toUpperCase()
                            }
                          />
                        </Typography>
                        <Typography sx={displayFlex}>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              cursor: 'pointer',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                          </Typography>
                        </Typography>
                      </Typography>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Contact
                      row={row?.buyerDetails}
                      directcomm={directcomm}
                      index={null}
                    />
                  </TableCell>
                  <TableCell>
                    <Box component={'div'}>
                      <LinearProgressBarWithPercentage
                        value={row?.buyerDetails?.rediness}
                        rediness={row?.buyerDetails?.rediness}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography textAlign={'left'}>
                        {row?.buyerDetails?.is66Signed == 0 ? (
                          <GreyPaper />
                        ) : (
                          <ColorPaper />
                        )}
                      </Typography>
                      <Typography
                        textAlign={'left'}
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '9.69px',
                          fontWeight: '400px',
                          color:
                            row?.buyerDetails?.is66Signed === 0
                              ? '#707b91'
                              : '#6C2AD2',
                        }}
                      >
                        {'s66W'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <OfferContainer
                      row={row}
                      data={row?.buyerOfferDetails?.offerPrice}
                      agentReg={true}
                      offerIsFinal={row?.buyerOfferDetails?.offerIsFinal}
                      userTypeValue={userTypeValue}
                      isMarket={row?.buyerOfferDetails?.isMarket}
                    />
                  </TableCell>
                  <TableCell>
                    {[
                      ...new Map(
                        counterOfferBuyerLists
                          .filter(
                            (buyer) =>
                              buyer?.buyerId == row?.buyerDetails?.user?.userId
                          )
                          .map((buyer) => [buyer?.historyCreated, buyer])
                      ).values(),
                    ].map((buyer, offerIndex) => (
                      <>
                        <Typography
                          key={offerIndex}
                          sx={{ fontFamily: 'Poppins', fontSize: '14px' }}
                        >
                          {buyer?.historyCreated
                            ? dayjs(buyer?.historyCreated).format(
                                'HH:mm:ss DD-MM-YYYY'
                              )
                            : ''}
                        </Typography>
                        <br />
                      </>
                    ))}
                  </TableCell>
                </TableRow>
              );
            }
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CounterOfferTable;
